import common from '@/utils/common'
import * as query from '@/queries/stock'

const defaultState = function () {
  return {
    mode: 0,
    returnList: false,
    tableSetList: [{}],
    tdLists: [],
    totalCount: 0,
    listIndex: -1,
    currentPage: 0,
    size: 10,
    stockAlertOptions: [],
    isAndSearch: false,
    searchKeyword: '',
    searchConditions: {
      siteCodes: {
        type: 'MultiSelector',
        title: 'サイト',
        property: 'siteCode',
        display: false,
        value: [],
        options: []
      },
      stockTypes: {
        type: 'MultiSelector',
        title: '在庫種別',
        property: '',
        display: false,
        value: '',
        options: [
          { code: 0, name: 'すべて' },
          { code: 1, name: '通常' },
          { code: 2, name: '予約' },
          { code: 3, name: '取寄' }
        ]
      }
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    async update (state, condition) {
      const noQuery = common.addGraphQlCondition(query.GRAPH_QL_QUERY_STOCK_ALERT_LIST, condition)
      const res = await common.postGraphQl(noQuery)
      state.tdLists = common.getValueByPath(res.data, 'data.ecStockAlertItems.edges')
    }
  },
  getDefaultState: defaultState
}



// WEBPACK FOOTER //
// ./src/store/pages/stockAlert.js